__turbopack_context__.v({
  "bar": "jzAHiq_bar",
  "bars": "jzAHiq_bars",
  "borderline": "jzAHiq_borderline",
  "captions": "jzAHiq_captions",
  "fill": "jzAHiq_fill",
  "fits": "jzAHiq_fits",
  "number": "jzAHiq_number",
  "rise": "jzAHiq_rise",
  "scale": "jzAHiq_scale",
});
